module.exports = __webpack_public_path__ + "static/media/sceplenie.cb4738dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/sceplenie.png
// module id = 166
// module chunks = 0